import { Button } from '@heathmont/moon-components';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';

const FloatingButton = styled(Button)`
  && {
    width: ${rem(56)};
    height: ${rem(56)};
    border-radius: ${rem(56)};
    position: fixed;
    z-index: 2;
    left: ${rem(20)};
    bottom: ${rem(20)};
    background-color: #fff;
    box-shadow:
      0px 8px 24px -6px rgba(0, 0, 0, 0.16),
      0px 0px 1px rgba(0, 0, 0, 0.4);
  }
`;

export default FloatingButton;
